import { phoneShapeOrNull } from "@shared/phone-shape";

/**
 * Strażnik WYŚWIETLANIA telefonu — nie walidator numeru.
 *
 * VP-243: makra reklamowe Meta trafiały do pola telefonu po przejściu przez
 * form-urlencode (spacje → '+'), np. nazwa kampanii "... AUTOWEBINAR 5 | 18.12.2025"
 * zapisywała się jako "++++5++18122025+". Gdy lead nie ma imienia ani maila, UI
 * spadał na telefon jako etykietę i pokazywał ten bełkot zamiast nazwy.
 *
 * Backend odrzuca takie wartości przy zapisie (`sanitizePhone`), ale wiersze
 * sprzed poprawki zostają w bazie do czasu backfillu — dlatego widok też musi się
 * bronić. Reguła struktury jest wspólna (`@shared/phone-shape`); pełna walidacja
 * E.164 zostaje po stronie backendu, żeby nie dokładać libphonenumber do bundla.
 */
export function isDisplayablePhone(phone: string | null | undefined): boolean {
  return phoneShapeOrNull(phone) !== null;
}

/**
 * Telefon nadający się na etykietę leada — `null`, gdy wartość nie jest numerem.
 * Pozwala pisać `name || email || displayablePhone(phone) || fallback`.
 */
export function displayablePhone(phone: string | null | undefined): string | null {
  return isDisplayablePhone(phone) ? (phone as string) : null;
}
